import AnimationFrame from "./AnimationFrame";

// window.requestAnimationFrameを使用して定期実行(1/60秒毎)されるアニメーションループを実行します
export class AnimationManager {
  private elapsedTimeMax: number;
  private lastTime: number;
  private isRunning: boolean;
  private isInitialized: boolean;

  public frame: AnimationFrame | null = null;

  constructor() {
    this.elapsedTimeMax = 1.0 / 10.0;
    this.lastTime = new Date().getTime();
    this.isRunning = false;
    this.isInitialized = false;
  }

  private initialize() {
    if (this.frame) {
      this.frame.initialize();
    }
  }

  private update(elapsedTime: number) {
    if (this.frame) {
      this.frame.update(elapsedTime);
    }
  }

  private draw(elapsedTime: number) {
    if (this.frame) {
      this.frame.draw(elapsedTime);
    }
  }

  private tick() {
    const currentTime = new Date().getTime();
    let elapsedTime = (currentTime - this.lastTime) / 1000.0;
    elapsedTime = Math.min(Math.max(elapsedTime, 0.0), this.elapsedTimeMax);
    this.lastTime = currentTime;

    this.update(elapsedTime);
    this.draw(elapsedTime);
  }

  public run() {
    this.isRunning = true;
    if (!this.isInitialized) {
      this.isInitialized = true;
      this.initialize();
    }
    const animationLoop = () => {
      this.tick();
      if (this.isRunning) {
        this.requestAnimationFrame(animationLoop);
      }
    };
    animationLoop();
  }

  public stop() {
    this.isRunning = false;
  }

  // ブラウザによってrequestAnimationFrameを変更する
  private requestAnimationFrame = (() => {
    if (window.requestAnimationFrame) {
      return function (callback: FrameRequestCallback) {
        window.requestAnimationFrame(callback);
      };
    }

    if ((window as any).mozRequestAnimationFrame) {
      return function (callback: any) {
        (window as any).mozRequestAnimationFrame(callback);
      };
    }

    if ((window as any).oRequestAnimationFrame) {
      return function (callback: any) {
        (window as any).oRequestAnimationFrame(callback);
      };
    }

    if ((window as any).msRequestAnimationFrame) {
      return function (callback: any) {
        (window as any).msRequestAnimationFrame(callback);
      };
    }

    return (callback: any) => {
      const targetFPS = 60.0;
      const procTime = new Date().getTime() - this.lastTime;
      const waitTime = Math.max((1.0 / targetFPS) * 1000.0 - procTime, 0);
      window.setTimeout(callback, waitTime);
    };
  })();
}
